export default {
    path: '',
    component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
    children: [
        {
            name: 'distributor-notice-detail',
            path: '/distributor/notice/notice-detail',
            meta: {
                footer_margin_none: true,
            },
            component: () => import(`./index.vue`),
        },
    ]
};